import _objectSpread from "/home/diwakar/subsitereact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/home/diwakar/subsitereact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useEffect, forwardRef, useState, useImperativeHandle, createElement } from 'react';

var noop = function noop() {};

function useInterval(callback, delay, immediate) {
  var savedCallback = useRef(noop);
  useEffect(function () {
    savedCallback.current = callback;
  });
  useEffect(function () {
    if (!immediate) return;
    if (delay === null || delay === false) return;
    savedCallback.current();
  }, [immediate]);
  useEffect(function () {
    if (delay === null || delay === false) return undefined;

    var tick = function tick() {
      return savedCallback.current();
    };

    var id = setInterval(tick, delay);
    return function () {
      return clearInterval(id);
    };
  }, [delay]);
}

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

var LoadingBar = forwardRef(function (_ref, ref) {
  var progress = _ref.progress,
      _ref$height = _ref.height,
      _height = _ref$height === void 0 ? 2 : _ref$height,
      _ref$className = _ref.className,
      _className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      _color = _ref$color === void 0 ? 'red' : _ref$color,
      _ref$background = _ref.background,
      _background = _ref$background === void 0 ? 'transparent' : _ref$background,
      onLoaderFinished = _ref.onLoaderFinished,
      _ref$transitionTime = _ref.transitionTime,
      _transitionTime = _ref$transitionTime === void 0 ? 300 : _ref$transitionTime,
      _ref$loaderSpeed = _ref.loaderSpeed,
      _loaderSpeed = _ref$loaderSpeed === void 0 ? 500 : _ref$loaderSpeed,
      _ref$waitingTime = _ref.waitingTime,
      _waitingTime = _ref$waitingTime === void 0 ? 1000 : _ref$waitingTime,
      _ref$shadow = _ref.shadow,
      _shadow = _ref$shadow === void 0 ? true : _ref$shadow,
      _ref$containerStyle = _ref.containerStyle,
      _containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
      _ref$style = _ref.style,
      _style = _ref$style === void 0 ? {} : _ref$style,
      _ref$shadowStyle = _ref.shadowStyle,
      shadowStyleProp = _ref$shadowStyle === void 0 ? {} : _ref$shadowStyle,
      _ref$containerClassNa = _ref.containerClassName,
      _containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa;

  var isMounted = useRef(false);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      localProgress = _useState2[0],
      localProgressSet = _useState2[1];

  var _useState3 = useState({
    active: false,
    startingValue: 20,
    refreshRate: 1000
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      pressedContinuous = _useState4[0],
      setPressedContinuous = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      usingProps = _useState6[0],
      setUsingProps = _useState6[1];

  var _useState7 = useState({
    active: false,
    value: 20
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      pressedStaticStart = _useState8[0],
      setStaticStartPressed = _useState8[1];

  var initialLoaderStyle = {
    height: '100%',
    background: _color,
    transition: "all ".concat(_loaderSpeed, "ms ease"),
    width: '0%'
  };
  var loaderContainerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: _height,
    background: _background,
    zIndex: 99999999999,
    width: 100 + '%'
  };
  var initialShadowStyles = {
    boxShadow: "0 0 10px ".concat(_color, ", 0 0 10px ").concat(_color),
    width: '5%',
    opacity: 1,
    position: 'absolute',
    height: '100%',
    transition: "all ".concat(_loaderSpeed, "ms ease"),
    transform: 'rotate(3deg) translate(0px, -4px)',
    left: '-10rem'
  };

  var _useState9 = useState(initialLoaderStyle),
      _useState10 = _slicedToArray(_useState9, 2),
      loaderStyle = _useState10[0],
      loaderStyleSet = _useState10[1];

  var _useState11 = useState(initialShadowStyles),
      _useState12 = _slicedToArray(_useState11, 2),
      shadowStyle = _useState12[0],
      shadowStyleSet = _useState12[1];

  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  useImperativeHandle(ref, function () {
    return {
      continuousStart: function continuousStart(startingValue) {
        var refreshRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
        if (pressedStaticStart.active) return;

        if (usingProps) {
          console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
          return;
        }

        var val = startingValue || randomInt(10, 20);
        setPressedContinuous({
          active: true,
          refreshRate: refreshRate,
          startingValue: startingValue
        });
        localProgressSet(val);
        checkIfFull(val);
      },
      staticStart: function staticStart(startingValue) {
        if (pressedContinuous.active) return;

        if (usingProps) {
          console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
          return;
        }

        var val = startingValue || randomInt(30, 50);
        setStaticStartPressed({
          active: true,
          value: val
        });
        localProgressSet(val);
        checkIfFull(val);
      },
      complete: function complete() {
        if (usingProps) {
          console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");
          return;
        }

        localProgressSet(100);
        checkIfFull(100);
      }
    };
  });
  useEffect(function () {
    loaderStyleSet(_objectSpread({}, loaderStyle, {
      background: _color
    }));
    shadowStyleSet(_objectSpread({}, shadowStyle, {
      boxShadow: "0 0 10px ".concat(_color, ", 0 0 5px ").concat(_color)
    }));
  }, [_color]);
  useEffect(function () {
    if (ref) {
      if (ref && progress !== undefined) {
        console.warn('react-top-loading-bar: You can\'t use both controlling by props and ref methods to control the bar! Please use only props or only ref methods! Ref methods will override props if "ref" property is available.');
        return;
      }

      checkIfFull(localProgress);
      setUsingProps(false);
    } else {
      if (progress) checkIfFull(progress);
      setUsingProps(true);
    }
  }, [progress]);

  var checkIfFull = function checkIfFull(_progress) {
    if (_progress >= 100) {
      loaderStyleSet(_objectSpread({}, loaderStyle, {
        width: '100%'
      }));

      if (_shadow) {
        shadowStyleSet(_objectSpread({}, shadowStyle, {
          left: _progress - 10 + '%'
        }));
      }

      setTimeout(function () {
        if (!isMounted.current) {
          return;
        }

        loaderStyleSet(_objectSpread({}, loaderStyle, {
          opacity: 0,
          width: '100%',
          transition: "all ".concat(_transitionTime, "ms ease-out"),
          color: _color
        }));
        setTimeout(function () {
          if (!isMounted.current) {
            return;
          }

          if (pressedContinuous.active) {
            setPressedContinuous(_objectSpread({}, pressedContinuous, {
              active: false
            }));
            localProgressSet(0);
            checkIfFull(0);
          }

          if (pressedStaticStart.active) {
            setStaticStartPressed(_objectSpread({}, pressedStaticStart, {
              active: false
            }));
            localProgressSet(0);
            checkIfFull(0);
          }

          if (onLoaderFinished) onLoaderFinished();
          localProgressSet(0);
          checkIfFull(0);
        }, _transitionTime);
      }, _waitingTime);
    } else {
      loaderStyleSet(function (_loaderStyle) {
        return _objectSpread({}, _loaderStyle, {
          width: _progress + '%',
          opacity: 1,
          transition: _progress > 0 ? "all ".concat(_loaderSpeed, "ms ease") : ''
        });
      });

      if (_shadow) {
        shadowStyleSet(_objectSpread({}, shadowStyle, {
          left: _progress - 5.5 + '%',
          transition: _progress > 0 ? "all ".concat(_loaderSpeed, "ms ease") : ''
        }));
      }
    }
  };

  useInterval(function () {
    var random = randomInt(10, 20);

    if (localProgress + random < 90) {
      localProgressSet(localProgress + random);
      checkIfFull(localProgress + random);
    }
  }, pressedContinuous.active ? pressedContinuous.refreshRate : null);
  return createElement("div", {
    className: _containerClassName,
    style: _objectSpread({}, loaderContainerStyle, _containerStyle)
  }, createElement("div", {
    className: _className,
    style: _objectSpread({}, loaderStyle, _style)
  }, _shadow ? createElement("div", {
    style: _objectSpread({}, shadowStyle, shadowStyleProp)
  }) : null));
});
export default LoadingBar;